import Client from './Clients/AxiosClient'
import { parseFilters } from './utils/ParseFilters'
const resource = 'emails'

export default {
  send (data) {
    return Client.post(`${resource}/send`, data, { headers: { 'Content-Type': 'application/json' } })
      .then(response => response.data)
  }
}
